import { render, staticRenderFns } from "./DropdownLanguage.vue?vue&type=template&id=c6ff1fc6&scoped=true"
import script from "./DropdownLanguage.vue?vue&type=script&lang=js"
export * from "./DropdownLanguage.vue?vue&type=script&lang=js"
import style0 from "./DropdownLanguage.vue?vue&type=style&index=0&id=c6ff1fc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ff1fc6",
  null
  
)

export default component.exports